import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=4081270e&scoped=true"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"
import style0 from "./FormButtons.vue?vue&type=style&index=0&id=4081270e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4081270e",
  null
  
)

export default component.exports